// extracted by mini-css-extract-plugin
export default {"audio-svg":"audioPreview__audio-svg--jiGvi","audioSvg":"audioPreview__audio-svg--jiGvi"};